import { defineComponent as _defineComponent } from 'vue'
import BCXPoints from '@/components/molecules/BCXPoints.vue';
import BCXUserBadge from '@/components/molecules/BCXUserBadge.vue';
import { ProfileStoreKey } from '@/models/Profile';
import { BannerUserState } from '@/models/UserState';
import useProfileState from '@/state/profile/profileState';
import useQuickInfo from '@/state/quickInfo';
import { computed, PropType, toRefs } from 'vue';
import Chevron from '@/components/svg-components/Chevron.vue';
import { sortBy } from 'lodash';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBadgesLegend',
  props: {
  viewUser: {
    type: Object as PropType<BannerUserState>,
    default: undefined
  }
},
  setup(__props) {

const props = __props;

const BADGES_HELP_ARTICLE_LINK = '/wiki/help/8e4e76ff-d0c1-4461-9355-209f032196df';



const { viewUser } = toRefs(props);
const { tUserFallback: t } = useUser('self');
const { displayedSection } = useQuickInfo();
const {
  user,
} = useProfileState(ProfileStoreKey.QUICK_INFO, viewUser);
const reputationPoints = computed(() => Math.max(user.value?.reputationPoints ?? 0, 0));
const badges = computed(() => viewUser.value.badges);

const sortedBadges = computed(() => {
  const shownBadges: { badge: string; position: number }[] = [];
  if (!badges.value) return [];

  badges.value.forEach((badge) => {
    if (badge.includes('STRANGER_KEY')) {
      // do nothing
    } else if ((badge.includes('MEMBER') || badge.includes('RESIDENT'))
            && badges.value.length <= 4) {
      shownBadges.push({ badge, position: 2 });
    } else if (badge.includes('TEAM')) {
      shownBadges.push({ badge, position: 1 });
    } else if (badge.includes('EXPERTISE')
          || badge.includes('COMMUNICATION')
          || badge.includes('RECOMMENDATION')) {
      if (badge.includes('GOLD')) {
        shownBadges.push({ badge, position: 3 });
      } else {
        shownBadges.push({ badge, position: 4 });
      }
    } else if (badge.includes('NETWORKING')) {
      shownBadges.push({ badge, position: 5 });
    } else {
      shownBadges.push({ badge, position: 6 });
    }
  });

  return sortBy(shownBadges, ['position']);
});


return { __sfc: true,BADGES_HELP_ARTICLE_LINK, props, viewUser, t, displayedSection, user, reputationPoints, badges, sortedBadges, BCXPoints, BCXUserBadge, Chevron }
}

})